export default __webpack_public_path__ + "static/media/6.069bb519.pdf";